import { useQuery } from "@tanstack/react-query";
import { useAxios } from "../../utils/hooks/useAxios";
import { useSystem } from "@/utils/hooks/useLocation";

export const useGetPilgrimQuery = (id, queryOptions = {}) => {
  const { axiosProtected } = useAxios();
  const { currentSystem } = useSystem()
  let system = currentSystem === "makkah" ? "makkah" : "madina";
  return useQuery({
    queryKey: ["pilgrim", system, id],
    queryFn: ({ signal }) =>
      axiosProtected.get(`${system}/detailed-pilgrims/${id}`, { signal }),
    ...queryOptions,
  });
};

export const useGetPilgrimsQuery = (params = {}) => {
  const { axiosProtected } = useAxios();
  const { currentSystem } = useSystem();
  return useQuery({
    queryKey: ["pilgrims", params],
    queryFn: () =>
      axiosProtected.get(`${currentSystem}/detailed-pilgrims/list`, { params }),
  });
};
